import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Scheduler = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
              <div className="container px-0">
                <div class="shadowclass mt-4">
                  <div class="select-comparison my-0">
                    <div class="select-div bold-select">
                      <select
                        name="data[comparison]"
                        class="comparison pt-0"
                        id="comparison"
                      >
                        <option value="">Select Comparison</option>
                        <option value="0">Previous Period</option>
                        <option value="1">Same Period Previous Year</option>
                      </select>{" "}
                    </div>
                  </div>
                </div>
                <div className="shadowclass my-4">
                  <div className="col-12">
                    <div class="lastPublised" id="lastPublished">
                      Period Last Published 2022/05/22 05:00 am{" "}
                    </div>
                    <div class="event-alert scheduler-title mb-4 border-0">
                      <div className="d-flex col-md-3 align-items-center">
                        <a
                          href="/schedulers/weekly/dateStart:2022-05-22"
                          class="date_label"
                        >
                          <i class="iconSprites arrow-left"></i>{" "}
                        </a>{" "}
                        <span class="date-text">
                          May 23, 2022 - May 29, 2022
                        </span>
                        <a
                          href="/schedulers/weekly/dateStart:2022-05-30"
                          class="date_label"
                        >
                          <i class="iconSprites arrow-right-medium"></i>{" "}
                        </a>
                      </div>
                      <ul class="summary_filter add full-width col">
                        <li>
                          <a href="/schedulers/daily">Daily</a>{" "}
                        </li>
                        <li class="active">
                          <a href="/schedulers/weekly">Weekly</a>{" "}
                        </li>

                        <li>
                          <a class="plus-link " href="/shifts/shift_new">
                            <img src="/img/plus.svg" alt="" /> Add Shift
                          </a>
                        </li>

                        <li>
                          <a
                            class="plus-link "
                            href="javascript:void(0)"
                            id="add_allowance"
                          >
                            <img src="/img/plus.svg" alt="" /> Add Allowance
                          </a>
                        </li>
                      </ul>
                      <div class="clear"></div>
                    </div>

                    <div class="wekly-scroll-wdgt new-edit weekly wekly-scroll-wdgt-c1">
                      {/* <!-- print headings with date ---> */}
                      <div class="weekly-hdg">
                        <div class="wf-box">
                          <div class="indicate-sign indicate-sign-c2 disp-none">
                            <ul>
                              <li>
                                <i class="report-circle"></i> Absence
                              </li>
                              <li>
                                <i class="plus_icon"></i> Tardy
                              </li>
                            </ul>
                          </div>
                          <div class="wekly-txt-sign wekly-txt-sign-c2 disp-none">
                            <a href="#" class="txt-bdr-box hover-btns bor-rad">
                              L
                            </a>
                            <a
                              href="#"
                              class="txt-bdr-box hover-btns bor-rad mrglft20"
                            >
                              M
                            </a>
                          </div>
                          <div class="user-icon user-icon-c1">
                            <img src="/img/user-employee.svg" alt="" />{" "}
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-23"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">23 </div>
                            <div class="day-text">
                              Monday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">23 </div>
                            <div class="day-text">
                              May <br />
                              Mon{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-24"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">24 </div>
                            <div class="day-text">
                              Tuesday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">24 </div>
                            <div class="day-text">
                              May <br />
                              Tue{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-25"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">25 </div>
                            <div class="day-text">
                              Wednesday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">25 </div>
                            <div class="day-text">
                              May <br />
                              Wed{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-26"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">26 </div>
                            <div class="day-text">
                              Thursday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">26 </div>
                            <div class="day-text">
                              May <br />
                              Thu{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-27"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">27 </div>
                            <div class="day-text">
                              Friday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">27 </div>
                            <div class="day-text">
                              May <br />
                              Fri{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-28"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">28 </div>
                            <div class="day-text">
                              Saturday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">28 </div>
                            <div class="day-text">
                              May <br />
                              Sat{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box ">
                          <div class="confirm-btn">
                            <a
                              href="#_"
                              class="ad-hoc hover-btns confirm_daywise"
                              data-day_date="2022-05-29"
                            >
                              Confirm
                            </a>
                          </div>
                          <div class="day-date hide-small">
                            <div class="day-number">29 </div>
                            <div class="day-text">
                              Sunday <br />
                              May 2022{" "}
                            </div>
                          </div>

                          <div class="day-date show-small">
                            <div class="day-number">29 </div>
                            <div class="day-text">
                              May <br />
                              Sun{" "}
                            </div>
                          </div>
                        </div>
                        <div class="ws-box last-col-no-bor">
                          <div class="indicate-sign indicate-sign-c1">
                            <ul>
                              <li>
                                <i class="report-circle"></i> Absence
                              </li>
                              <li>
                                <i class="plus_icon"></i> Tardy
                              </li>
                            </ul>
                          </div>
                          <h5>Total</h5>
                        </div>
                        <div class="clear"></div>
                      </div>
                      {/* <!-- End of headings ---> */}

                      {/* <!-- printing rows -----> */}
                      <div class="wekly-dat-scroll-wdgt no-lp">
                        <div class="weekly-sched-mangement">
                          {/* <!-- print counting of shifts in each service group --> */}
                          <div class="wekly-hdg-row">
                            <div class="wf-box">
                              <h6>Kitchen</h6>
                            </div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box"></div>
                            <div class="ws-box last-col-no-bor">&nbsp;</div>
                          </div>
                          {/* <!-- End of print counting of shifts ----> */}

                          <div class="wekly-innr-row d-flex">
                            {/* <!-- print employee nick name, image, function etc --> */}
                            <div class="wf-box">
                              <div id="remove_this">
                                <div class="t-div-inner">
                                  <div class="indicate-circle">
                                    <img
                                      src="/img/../employee_images/1642043461.png"
                                      alt=""
                                    />{" "}
                                  </div>
                                  <div class="right-ws">
                                    <h4>
                                      <a href="/labor_settings/editEmployee/TW9jZWh5eklHc2VLN2x6UndHTVJVdz09">
                                        Joe
                                      </a>
                                    </h4>
                                    <h6 class="no-caps">Head Chef </h6>
                                  </div>
                                  <div class="clear"></div>
                                  <div class="indicate-sign">
                                    <ul>
                                      <li>
                                        <i class="report-circle"></i>0{" "}
                                      </li>
                                      <li>
                                        <i class="plus_icon"></i>0{" "}
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="wekly-txt-sign wekly-txt-sign-c1">
                                    <a
                                      href="/labor_settings/leave_request/employeeId:880"
                                      class="txt-bdr-box hover-btns bor-rad"
                                    >
                                      L
                                    </a>
                                    <a
                                      href="/labor_settings/medical_claim/employeeId:880"
                                      class="txt-bdr-box hover-btns bor-rad mrglft20"
                                    >
                                      M
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <!-- end of employee details ---> */}

                            {/* <!-- start printing shifts --> */}

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-23"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-23"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-24"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-24"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-25"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-25"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-26"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-26"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-27"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-27"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-28"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-28"
                                >
                                  Off
                                </a>
                              </div>
                            </div>

                            <div class="ws-box">
                              <input
                                type="hidden"
                                name="data[dailyShiftPay]"
                                value="107.52688172043"
                                class="dailyShiftPay"
                                id="dailyShiftPay"
                              />

                              <div class="wekly-sift-indictn allParent plus_icon smCircleBtn">
                                <a
                                  class="plusSign"
                                  href="/shifts/add_shift_individual/880/2022-05-29"
                                >
                                  +
                                </a>
                              </div>
                              <div class="wekly-sift-indictn allParent smCircleBtn">
                                <a
                                  class="off-on-btn offclickbtn"
                                  href="javascript:void(0)"
                                  eid="880"
                                  dt="2022-05-29"
                                >
                                  Off
                                </a>
                              </div>
                            </div>
                            {/* <!-- end of print shifts --> */}

                            {/* <!-- print sched, total, ot and pay --> */}
                            <div class="ws-box last-col-no-bor">
                              <ul class="total-list last-col-no-bor">
                                <li>
                                  <div class="left">Sched:</div>
                                  <div class="right">0.00 </div>
                                </li>
                                <li>
                                  <div class="left">Act:</div>
                                  <div class="right">0.00 </div>
                                </li>
                                <li>
                                  <div class="left">OT:</div>
                                  <div class="right">0.00 </div>
                                </li>
                                <li>
                                  <div class="left">Pay:</div>
                                  <div class="right">
                                    <span class="below640">$752.69 </span>
                                    <span class="eqOrAbove640">$752.69 </span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div class="clear"></div>
                            {/* <!-- End of print sched, total, ot and pay --> */}
                          </div>

                          {/* <!-- No owner row starts here --> */}
                          <div class="clear"></div>
                          {/* <!-- No owner row end here --> */}
                        </div>
                      </div>
                      {/* <!-- end of printing rows ----> */}
                    </div>
                  </div>
                  <div
                    className="accordion"
                    id="accordionPanelsStayOpenExample"
                  >
                    <div className="accordion-item">
                      <h2
                        className="accordion-header"
                        id="panelsStayOpen-headingNine2"
                      >
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#panelsStayOpen-collapseNine2"
                          aria-expanded="true"
                          aria-controls="panelsStayOpen-collapseNine2"
                        >
                          <div className="col d-flex align-items-center justify-content-between">
                            <h4 className="event-alert p-0 mb-0">Total</h4>
                          </div>
                        </button>
                      </h2>
                      <div
                        id="panelsStayOpen-collapseNine2"
                        className="accordion-collapse collapse show"
                        aria-labelledby="panelsStayOpen-headingNine2"
                      >
                        <div className="row mx-0 pendingShiftMs">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive wkly-btn-sec">
                                <div className="inner-space">
                                  <div class="tabel-row">
                                    <div class="wf-box">
                                      Forecasted Total Hours
                                    </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">
                                      <b>0.00</b>
                                    </div>
                                  </div>
                                  <div class="tabel-row">
                                    <div class="wf-box">
                                      Forecasted Total Hours
                                    </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">
                                      <b>0.00</b>
                                    </div>
                                  </div>
                                  <div class="tabel-row">
                                    <div class="wf-box">
                                      Forecasted Total Hours
                                    </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">0.00 </div>
                                    <div class="ws-box">
                                      <b>0.00</b>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2
                        className="accordion-header"
                        id="panelsStayOpen-headingNine3"
                      >
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#panelsStayOpen-collapseNine3"
                          aria-expanded="true"
                          aria-controls="panelsStayOpen-collapseNine3"
                        >
                          <div className="col d-flex align-items-center justify-content-between">
                            <h4 className="event-alert p-0 mb-0">Cumulative</h4>
                          </div>
                        </button>
                      </h2>
                      <div
                        id="panelsStayOpen-collapseNine3"
                        className="accordion-collapse collapse show"
                        aria-labelledby="panelsStayOpen-headingNine3"
                      >
                        <div className="row mx-0 upcomingShiftMs">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive">
                                <div class="tabel-row">
                                  <div class="wf-box">
                                    Forecasted Total Hours
                                  </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">
                                    <b>0.00</b>
                                  </div>
                                </div>
                                <div class="tabel-row">
                                  <div class="wf-box">
                                    Scheduled Total Hours
                                  </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">0.00 </div>
                                  <div class="ws-box">
                                    <b>0.00</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Scheduler;
